import React from 'react';
import LogoFarm from 'react-scale/components/ui/logo-grid';
import Section from 'react-scale/components/ui/section';

const Farm = props => (
  <Section {...props}>
    <LogoFarm {...props} />
  </Section>
);

export default Farm;
